module.exports = __webpack_public_path__ + "static/media/Spinner.f864a890.gif";